import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RepairDto} from "../../../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CreateRepairService {

  constructor(private httpClient: HttpClient) { }

  public CreateRepair(claimId: number): Observable<RepairDto> {
    return this.httpClient.post<RepairDto>(`${environment.apiServer}/CreateRepair`, null, {params: {claimId: claimId}});
  }
}
